module.exports = __webpack_public_path__ + "static/media/3d-plan_general_Nemo.b7239887.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general_Nemo.svg
// module id = 945
// module chunks = 0